/**
 * UserFactsProvider.ts
 *
 * Module for user facts provider.
 */
import { getDynamicSetting } from "../Configuration/DynamicConfiguration";
import { TULIPS_INGESTION_TIME, TULIPS_LOAD_TIMEOUT } from "./TargetedMessagingConstants";
import * as AssetsProvider from "./AssetsProvider";
import * as Logging from "../Logging/Logging";
import { createTimeoutPromise } from "../Utils";
export class UserFactsProvider {
  constructor() {
    this.loadAsyncTriggered = false;
    this.userFacts = [];
    this.nameAndUserFactMap = {};
  }
  load() {
    if (!this.loadAsyncTriggered) {
      this.loadAsync();
      this.loadAsyncTriggered = true;
    }
    return this.userFacts || [];
  }
  loadAsync() {
    const userFactsPromise = AssetsProvider.get().getUserFacts().then(userFacts => {
      this.loadUserFacts(userFacts);
    });
    const timeoutMilliseconds = getDynamicSetting("TulipsLoadTimeout" /* tulipsLoadTimeout */, TULIPS_LOAD_TIMEOUT);
    const timeoutPromise = createTimeoutPromise(timeoutMilliseconds, userFactsPromise);
    return timeoutPromise.then(() => this.userFacts).catch(() => {
      if (!this.userFacts || this.userFacts.length <= 0) {
        this.loadUserFacts(AssetsProvider.get().getCachedUserFacts());
      }
      return this.userFacts;
    }).catch(() => this.userFacts);
  }
  getUserFact(userFactName) {
    return this.nameAndUserFactMap[userFactName];
  }
  loadUserFacts(response) {
    if (response) {
      this.userFacts = response || [];
      this.userFacts.map(userFact => {
        this.nameAndUserFactMap[userFact.userFactName] = userFact;
      });
      this.loadAsyncTriggered = true;
      this.logUserFactInfo(this.userFacts);
    }
  }
  logUserFactInfo(userFacts) {
    if (!userFacts || userFacts.length <= 0) {
      return;
    }
    const tulipsIngestionTimeInterval = getDynamicSetting("TulipsIngestionTimeInterval" /* tulipsIngestionTimeInterval */, TULIPS_INGESTION_TIME);
    if (tulipsIngestionTimeInterval <= 0) {
      return;
    }
    let userFactProperties;
    try {
      const nowDate = Date.now();
      const isExpired = rawItemDate => {
        const itemDate = Date.parse(rawItemDate);
        return !isNaN(itemDate) ? nowDate - itemDate > tulipsIngestionTimeInterval : true;
      };
      const factInfo = {
        Count: userFacts.length,
        RefreshTime: tulipsIngestionTimeInterval,
        IngestionTime: userFacts[0].clientIngestionDateTime,
        SourcesExpired: userFacts.filter(userFact => userFact && isExpired(userFact.sourceDateTime)).length || undefined,
        StoragesExpired: userFacts.filter(userFact => userFact && isExpired(userFact.storageDateTime)).length || undefined,
        IngestionsExpired: userFacts.filter(userFact => userFact && isExpired(userFact.clientIngestionDateTime)).length || undefined
      };
      userFactProperties = {
        Message: "UserFacts",
        Data: JSON.stringify(factInfo)
      };
    } catch (error) {
      userFactProperties = {
        ErrorMessage: "Error getting UserFact info"
      };
    }
    Logging.getLogger().logEvent(Logging.EventIds.UserFacts.Provider.Info.VALUE, 3 /* Info */, userFactProperties);
  }
}